"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _utils = require("@/utils");
var _subscriptions = require("@/api/subscriptions");
var _organizations = require("@/api/organizations");
var _index = _interopRequireDefault(require("@/components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SubscriptionList',
  components: {
    SearchBox: _index.default
  },
  data: function data() {
    return {
      tableLoading: false,
      query: {
        q: ''
      },
      page: 1,
      limit: 10,
      total: 0,
      organizationsMap: null,
      subscriptionList: [],
      allSubscriptions: []
    };
  },
  computed: {
    pagedSubscriptionList: function pagedSubscriptionList() {
      return this.subscriptionList;
    }
  },
  created: function created() {
    this.fetchSubscriptions();
  },
  methods: {
    search: function search() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.page = page;
      this.fetchSubscriptions();
    },
    fetchSubscriptions: function fetchSubscriptions() {
      var _this = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      if (token) {
        Promise.resolve().then(function () {
          if (_this.organizationsMap) {
            return Promise.resolve();
          }
          return (0, _organizations.getAllOrganizations)(token).then(function (response) {
            var map = {};
            if (response.data && response.data.rows) {
              response.data.rows.forEach(function (org) {
                map[org.id] = org.name;
              });
            }
            _this.organizationsMap = map;
          }).catch(function (err) {
            (0, _log.showDebugLog)('getAllOrganizations-error', err);
            _this.organizationsMap = {};
          });
        }).then(function () {
          var queryParams = {
            page: _this.page,
            limit: _this.limit
          };
          if (_this.query.q) {
            queryParams.q = _this.query.q;
          }
          return (0, _subscriptions.getSubscriptionList)(token, queryParams).then(function (response) {
            var rows = response.data.rows || [];
            _this.subscriptionList = rows.map(function (item) {
              return {
                id: item.id,
                tenant: (0, _utils.getTenantLabel)(item.metadata ? item.metadata.tenant : ''),
                organization: _this.organizationsMap[item.organizationId] || item.organizationId || '',
                title: item.title
              };
            });
            _this.total = response.data.count || _this.subscriptionList.length;
            _this.tableLoading = false;
          });
        }).catch(function (error) {
          (0, _log.showDebugLog)('getSubscriptionList-error', error);
          _this.loadMockSubscriptions();
        });
      } else {
        this.loadMockSubscriptions();
      }
    },
    loadMockSubscriptions: function loadMockSubscriptions() {
      var list = this.allSubscriptions;
      if (this.query.q) {
        var q = this.query.q.toLowerCase();
        list = list.filter(function (item) {
          return item.title && item.title.toLowerCase().includes(q) || item.id && item.id.toLowerCase().includes(q) || item.tenant && item.tenant.toLowerCase().includes(q) || item.organization && item.organization.toLowerCase().includes(q);
        });
      }
      var start = (this.page - 1) * this.limit;
      var end = start + this.limit;
      this.subscriptionList = list.slice(start, end);
      this.total = list.length;
      this.tableLoading = false;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.fetchSubscriptions();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.fetchSubscriptions();
    }
  }
};